import { render } from "./UpPwd.vue?vue&type=template&id=6da41548"
import script from "./UpPwd.vue?vue&type=script&lang=js"
export * from "./UpPwd.vue?vue&type=script&lang=js"

import "./UpPwd.vue?vue&type=style&index=0&id=6da41548&lang=css"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__